import curd from '../curd'

const BASE_PATH = '/org/device'

export default curd(BASE_PATH)



// WEBPACK FOOTER //
// ./src/apis/modules/OrgDevice.js